import { combineReducers } from "redux";
import { loginReducer } from "./loginReducer";
import { tokenReducer } from "./tokenReducer";
import { notificationsReducer } from "./notificationsReducer";
import { contractReducer } from "./contractReducer";
import { zetLessonReducer } from "./zetLessonReducer";
import { deadLockreducer } from "./deadLockreducer";
import { menuReducer } from "./menuReducer";
import { RESET_NOTIFICATIONS, RESET_STORE } from "../types";
import { errorReducer } from "./errorReducer";

const appReducer = combineReducers({
  isValidLogin: loginReducer,
  token: tokenReducer,
  notifications: notificationsReducer,
  contract: contractReducer,
  zetLessonReducer: zetLessonReducer,
  deadLock: deadLockreducer,
  menu: menuReducer,
  error: errorReducer,
});

export const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  } else if (action.type === RESET_NOTIFICATIONS) {
    state.notifications = {
      count: 0,
      notificationsSummaries: null,
      currentNotificationData: null,
      open: false,
      openElectronicConsents: false,
      lssBlockNotifications: null,
      currentNotificationIndex: 0,
    };
    state.deadLock = {
      isDead_lock: false,
      dead_lock_message: "",
    };
  }
  return appReducer(state, action);
};
